"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupCategoriesWrapper = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function groupCategoriesWrapper(Highcharts) {
    var wrap = Highcharts.wrap;
    function hideGridInXAxis() {
        if (this.labelsGrid) {
            // hide the grid (or border) that covers X axis
            this.labelsGrid.hide();
        }
    }
    wrap(Highcharts.Axis.prototype, "render", function (proceed) {
        // default behaviour
        // eslint-disable-next-line prefer-rest-params
        proceed.apply(this, Array.prototype.slice.call(arguments, 1));
        hideGridInXAxis.call(this);
    });
}
exports.groupCategoriesWrapper = groupCategoriesWrapper;
//# sourceMappingURL=group-categories-wrapper.js.map